module.exports = __webpack_public_path__ + "img/info-icon.e5d74da5.svg";